import { TextCell } from '@common/components/TextCell';

interface DepositDateCellProps {
	/** Formatted date string */
	date?: string;
}

export const DepositDateCell = ({ date }: DepositDateCellProps) => {
	return <TextCell value={date} />;
};
